import { OverlayPanel } from "primereact/overlaypanel"
import { useRef } from "react"

export default function RefHelp(props) {
  const op = useRef(null)

  const marginRight = !!props.marginRight ? props.marginRight : "10px"
  const marginLeft = !!props.marginLeft ? props.marginLeft : "0px"
  return (
    <>
      <button
        type="button"
        style={{
          height: "30px",
          width: "20px",
          marginRight: marginRight,
          marginLeft: marginLeft,
        }}
        onClick={(e) => {
          op.current.toggle(e)
        }}
      >
        <span
          className="material-icons"
          style={{ verticalAlign: "middle", color: "blue" }}
        >
          help
        </span>
      </button>
      <OverlayPanel ref={op} dismissable>
        {props.content}
      </OverlayPanel>
    </>
  )
}
